module.exports = __webpack_public_path__ + "img/physiotherapist.b8332757.png";